import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SnackbarService } from '@app/core/services/snackbar.service';
import { IntegrationSettings } from '@app/modules/site-settings-integrations/models/integrations.model';
import { IntegrationsService } from '@app/modules/site-settings-integrations/services/integrations.service';
import { OverlayService } from '@app/shared/components/overlay/overlay.service';
import { TranslateService } from '@ngx-translate/core';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-integration-general-tab',
  templateUrl: './integration-general-tab.component.html',
  styleUrls: ['./integration-general-tab.component.scss']
})
export class IntegrationGeneralTabComponent implements OnInit {
  @Input() integrationSettings: IntegrationSettings = null;
  @Output() saved = new EventEmitter<void>();
  @Output() created = new EventEmitter<string>();
  @Output() cancelled = new EventEmitter<void>();

  public formId: string = 'frm_kOhKZciaDnFl5r';
  public formData: any;
  public getFormData: boolean = false;
  public formValid: boolean = false;

  constructor(
    private translate: TranslateService,
    private snackbarService: SnackbarService,
    private overlayService: OverlayService,
    private integrationService: IntegrationsService,
  ) { }

  ngOnInit(): void {
    this.buildFormData();
  }

  get isCreateMode(): boolean {
    return !this.integrationSettings;
  }

  buildFormData() {
    this.formData = {
      description: this.integrationSettings ? this.integrationSettings.description : null,
      status: this.integrationSettings ? this.integrationSettings.status : false,
      integration: this.integrationSettings ? this.integrationSettings.integration.id : null,
      subject: this.integrationSettings && this.integrationSettings.failureEmail ? this.integrationSettings.failureEmail.subject : null,
      body: this.integrationSettings && this.integrationSettings.failureEmail ? this.integrationSettings.failureEmail.body : null,
      recipients: this.integrationSettings && this.integrationSettings.failureEmail ? this.integrationSettings.failureEmail.recipients : [],
    };
  }

  formDataEmitted(formDataEmitted) {
    this.overlayService.show();

    const integrationPayload = {
      integration: formDataEmitted.integration,
      description: formDataEmitted.description,
      status: formDataEmitted.status,
      failureEmail: {
        subject: formDataEmitted.subject,
        body: formDataEmitted.body,
        recipients: formDataEmitted.recipients
      }
    };

    if (this.isCreateMode) {
      this.createIntegration(integrationPayload);
    } else {
      this.updateIntegration(integrationPayload);
    }
  }

  formStatusUpdated(formValid: boolean) {
    this.formValid = formValid;
  }

  private createIntegration(integrationPayload) {
    this.integrationService.createIntegration(integrationPayload)
      .pipe(finalize(() => this.overlayService.hide()))
      .subscribe(res => {
        this.snackbarService.openSnackBar(this.translate.instant('Integrations-Created'), 'clear', 'success');
        this.created.emit(res.integrationSettingsId);
      });
  }

  private updateIntegration(integrationPayload) {
    this.integrationService.updateIntegration(this.integrationSettings.id, integrationPayload)
      .pipe(finalize(() => this.overlayService.hide()))
      .subscribe(() => {
        this.snackbarService.openSnackBar(this.translate.instant('Integrations-Updated'), 'clear', 'success');
        this.saved.emit();
      });
  }
}
